import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import {
  getEntryCardData,
  AddAssetEntryCard,
  AIGCHandler,
  isValidXandrAccount,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useImageCardContainerStyle } from '../../styles';

export const AssetsEntryCardContainer = ({
  i18n,
  aid,
  cid,
  oDataConfig,
  navigation,
  isAdsStudioAIGCMVPEnabled,
  isAIGCRegionRestricted,
  notificationApi,
  logger,
  permissions,
}) => {
  const classes = useImageCardContainerStyle();
  const openSystemUploadRef = useRef(null);

  const isXandrIntEnabled = useMemo(() => permissions.dynamic.XandrIntegrationEnabled, [permissions]);
  // eslint-disable-next-line no-restricted-globals
  const { data: account } = useJsData(jsData => (isXandrIntEnabled ? jsData.Account.find(aid) : Promise.resolve()), [aid, isXandrIntEnabled]);
  const isXandrIntegrationEnabled = useMemo(() => (isXandrIntEnabled ? isValidXandrAccount(account) : false), [account, isXandrIntEnabled]);

  const cardData = getEntryCardData({
    i18n,
    isImagePage: true,
    onClickCreate: () => {
      AIGCHandler(isAdsStudioAIGCMVPEnabled, isAIGCRegionRestricted, notificationApi, i18n, () => {
        navigation.gotoAIGenerationPanelPage();
      });
    },
    onClickUpload: () => {
      openSystemUploadRef.current = {};
      navigation.gotoUploadFilesPanelPage({
        aid, cid, oDataConfig, i18n, mode: 'image', openSystemUpload: openSystemUploadRef.current,
      });
    },
    onClickStock: () => {
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from shutterstock');
      }
      navigation.gotoStockImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickInvest: () => {
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from invest');
      }
      navigation.gotoInvestImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickWebsite: () => {
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from website');
      }
      navigation.gotoWebsiteImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    isXandrIntegrationEnabled,
  });

  return (
    <>
      <div className={mergeClasses('card-container', classes.cardContainer)}>
        {cardData.map(card => (
          <AddAssetEntryCard
            key={card.key}
            id={card.key}
            description={card.description}
            title={card.title}
            imageSrc={card.image}
            onClick={card.onClick}
            isFillWidth
          />
          ))}
      </div>
    </>
  );
};


AssetsEntryCardContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({
    gotoWebsiteImagePanelPage: PropTypes.func,
    gotoStockImagePanelPage: PropTypes.func,
    gotoUploadFilesPanelPage: PropTypes.func,
    gotoAIGenerationPanelPage: PropTypes.func,
    gotoInvestImagePanelPage: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  isAIGCRegionRestricted: PropTypes.bool.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }),
};

AssetsEntryCardContainer.defaultProps = {
  permissions: { dynamic: {} },
};
